import React, { useCallback, useState } from 'react'
import {
  SelectArrayInputProps,
  ReferenceArrayInput,
  AutocompleteArrayInput,
  useLocaleState,
} from 'react-admin'
import { COMMON_FIELDS } from '../../providers/localization/constant'

const defaultProps = {
  source: 'branches',
}

export const BranchMultiSelectInput: React.FC<SelectArrayInputProps> = ({ source, ...props }) => {
  const [locale] = useLocaleState()
  const [filters, setFilters] = useState({ name: '' })
  const optionRenderer = useCallback(
    (choice): string => `${choice['branch_code']} ${choice[`branch_name_${locale}`] || choice['branch_name_th']}`,
    [locale],
  )

  return (
    <ReferenceArrayInput
      label={`${COMMON_FIELDS}.specific_branches.label`}
      source={source}
      reference='branches'
      sort={{ field: 'branch_code', order: 'ASC' }}
      filter={filters}
    >
      <AutocompleteArrayInput
        optionText={optionRenderer}
        fullWidth
        label={`${COMMON_FIELDS}.specific_branches.label`}
        setFilter={(searchText: string): void => setFilters({ name: searchText })}
        source={source}
        {...props}
      />
    </ReferenceArrayInput>
  )
}

BranchMultiSelectInput.defaultProps = defaultProps
